import React, { lazy } from 'react';
import { CheckIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-8 sm:py-12 px-4 bg-brand-sage-light rounded-2xl my-6 sm:my-8" data-id="element-165">
      <div className="max-w-xl mx-auto text-center" data-id="element-166">
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-text-main mb-6" data-id="element-167">
          Die Lösung, auf die Sie gewartet haben
        </h2>

        <div className="mb-6" data-id="element-168">
          <a href="#pricing" className="block cursor-pointer" data-id="element-169">
            <img src="https://cdn.magicpatterns.com/uploads/1T9hQF7qcyLX9WVP3qmGdh/metabolik-alemania-.webp" alt="Metabolik Pro System" loading="lazy" className="w-full h-auto object-contain drop-shadow-lg max-w-md mx-auto" data-id="element-170" />
          </a>
        </div>

        <div className="bg-white p-5 sm:p-6 rounded-xl border border-brand-sage/30 text-left" data-id="element-171">
          <h3 className="text-xl font-serif font-bold text-brand-olive mb-2" data-id="element-172">
            METABOLIK PRO
          </h3>
          <p className="text-sm sm:text-base text-brand-text-main font-medium mb-4" data-id="element-173">
            Ohne Zucker. Ohne Gluten. Mit vollem Genuss.
          </p>
          <p className="text-xs sm:text-sm text-brand-text-muted mb-5 leading-relaxed" data-id="element-174">
            500 getestete Rezepte für jede Mahlzeit — entwickelt für Menschen
            mit Diabetes, Glutenintoleranz und chronischer Entzündung. Alle
            Zutaten bei Rewe, Edeka, Lidl und Aldi erhältlich.
          </p>

          <div className="grid grid-cols-2 gap-3" data-id="element-175">
            {['Ohne Zucker', 'Ohne Gluten', 'Schnell & Einfach', 'Für jeden Tag'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-176">
                <CheckIcon className="w-4 h-4 text-brand-olive shrink-0" strokeWidth={3} data-id="element-177" />
                <span className="text-xs sm:text-sm font-bold text-brand-text-main" data-id="element-178">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}